<template>
  <TheMaster
    v-if="$store.state.master.isSignin"
    :color="true"
    title="장소"
    description="장소를 선택할 수 있어요."
  >
    <a-card title="1차 카테고리">
      <a-form layout="inline" @submit="onAddFirst">
        <a-form-item>
          <a-input v-model="category" placeholder="1차 카테고리" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="plus" @click="onAddFirst">추가</a-button>
        </a-form-item>
      </a-form>
      <a-list size="small" bordered :dataSource="firsts">
        <a-list-item slot="renderItem" slot-scope="item">
          <a slot="actions">
            <a-icon type="delete" @click="onDeleteFirst(item)" />
          </a>
          {{item}}
        </a-list-item>
      </a-list>
    </a-card>
    <a-card title="2차 카테고리" style="margin-top: 1em;">
      <a-radio-group @change="onChangeFirst" v-model="selected">
        <a-radio-button :value="name" v-for="name in firsts" :key="name">{{name}}</a-radio-button>
      </a-radio-group>
      <a-list
        v-if="selected"
        style="margin-top: 1em;"
        size="small"
        bordered
        :dataSource="secondary"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a slot="actions">
            <a-icon type="delete" @click="onDeleteSecondary(item)" />
          </a>
          {{item}}
        </a-list-item>
      </a-list>
      <a-form v-if="selected" layout="inline" @submit="onAddSecondary">
        <a-form-item>
          <a-input v-model="secondaryCategory" placeholder="2차 카테고리" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="plus" @click="onAddSecondary">추가</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </TheMaster>
</template>
<script>
import TheMaster from "@/components/Master/TheMaster";
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";

export default {
  name: "MasterQuestion",
  components: { TheMaster },
  mounted() {
    this.onRefresh();
  },
  methods: {
    async onRefresh() {
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/master/location`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.firsts = data.location;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "장소 정보를 가져올 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "장소 정보를 가져올 수 없습니다."
        });
      }
    },
    async onChangeFirst() {
      try {
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/master/location/details?first=${this.selected}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.secondary = data.location;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "장소 정보를 가져올 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "장소 정보를 가져올 수 없습니다."
        });
      }
    },
    async onAddFirst() {
      try {
        if (this.category.length === 0) {
          return config.alert.mixin({
            type: "error",
            title: "카테고리 이름을 입력해주세요."
          });
        }

        const { data } = await Axios.post(
          `${config.hostname}/v1/master/location`,
          { first: this.category },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.onRefresh();
              this.category = "";
              config.alert.mixin({
                type: "success",
                title: "카테고리를 추가했습니다."
              });
              break;
            case OPCODE.EXISTS:
              config.alert.mixin({
                type: "error",
                title: "이미 같은 이름의 카테고리가 있습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "카테고리를 추가할 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "카테고리를 추가할 수 없습니다."
        });
      }
    },
    async onAddSecondary() {
      try {
        if (this.secondaryCategory.length === 0) {
          return config.alert.mixin({
            type: "error",
            title: "카테고리 이름을 입력해주세요."
          });
        }

        const { data } = await Axios.post(
          `${config.hostname}/v1/master/location`,
          { first: this.selected, secondary: this.secondaryCategory },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.onChangeFirst();
              this.secondaryCategory = "";
              config.alert.mixin({
                type: "success",
                title: "카테고리를 추가했습니다."
              });
              break;
            case OPCODE.EXISTS:
              config.alert.mixin({
                type: "error",
                title: "이미 같은 이름의 카테고리가 있습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "카테고리를 추가할 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "카테고리를 추가할 수 없습니다."
        });
      }
    },
    async onDeleteFirst(first) {
      const self = this;
      this.$confirm({
        title: `“${first}”`,
        content: "정말로 해당 카테고리를 삭제하시겠습니까?",
        okText: "네, 삭제합니다.",
        okType: "danger",
        cancelText: "아니요",
        onOk() {
          self.onDeleteFirstReq(first);
        },
        onCancel() {}
      });
    },
    async onDeleteFirstReq(first) {
      try {
        const {
          data
        } = await Axios.delete(
          `${config.hostname}/v1/master/location?first=${first}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.selected = "";
              this.onRefresh();
              config.alert.mixin({
                type: "success",
                title: "카테고리를 성공적으로 삭제하였습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "카테고리를 삭제할 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "카테고리를 삭제할 수 없습니다."
        });
      }
    },
    async onDeleteSecondary(secondary) {
      const self = this;
      this.$confirm({
        title: `“${secondary}”`,
        content: "정말로 해당 카테고리를 삭제하시겠습니까?",
        okText: "네, 삭제합니다.",
        okType: "danger",
        cancelText: "아니요",
        onOk() {
          self.onDeleteSecondaryReq(secondary);
        },
        onCancel() {}
      });
    },
    async onDeleteSecondaryReq(secondary) {
      try {
        const {
          data
        } = await Axios.delete(
          `${config.hostname}/v1/master/location?first=${this.selected}&secondary=${secondary}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.onChangeFirst();
              config.alert.mixin({
                type: "success",
                title: "카테고리를 성공적으로 삭제하였습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "카테고리를 삭제할 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "카테고리를 삭제할 수 없습니다."
        });
      }
    }
  },
  data() {
    return {
      selected: "",
      category: "",
      firsts: [],
      secondary: [],
      secondaryCategory: ""
    };
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>